export default "__VITE_ASSET__Bo61uzKm__"